<template>
  <Header>
    <template v-slot:title>御葬儀プラン</template>
    <template v-slot:subtitle>Plan</template>
    <template v-slot:leadtext>
      規模やご予算、ご都合をお伺いし、
      <br />
      最適な御葬儀を提案いたします。
    </template>
    <template v-slot:text>
      ご家族だけの葬儀からご会葬の方々が多い社葬まで、大小問わず要望に合わせた葬儀のご提案をいたします。安心してお任せいただけるよう、総額プランにてご案内させていただいております。
      <br />
      また、返礼品やお食事も、ご要望にあわせてご用意させていただきます。
    </template>
  </Header>
  <section id="contents">
    <div class="plan-wrap">
      <div class="plan-item">
        <div class="tx">
          <h3>基本プランのご案内</h3>
          <p>
            天聖閣の御葬儀プランは、総額プランでございます。
            一般的な葬儀に必要なものはすべて込みでご案内しておりますのでご安心ください。
            会葬礼状・礼品などのお返しや、お食事についても、別料金にてご案内しております。
          </p>
        </div>
        <div class="basicplan">
          <h4>基本プランに含まれるもの</h4>
          <ul class="grid">
            <li class="item" v-for="(item, i) in basicplan" :key="i">
              <img
                :src="
                  require('../assets/images/plan/basicplan' + (i + 1) + '.svg')
                "
                :alt="item"
              />
            </li>
          </ul>
          <p>
            ※案内看板は、家族葬・直葬を除く。生花ダルマ・供物等は別途注文となります。
          </p>
        </div>
        <div class="advancedplan">
          <h4>ご要望に応じて追加・変更可能なもの</h4>
          <ul class="grid">
            <li class="item" v-for="(item, i) in advancedplan" :key="i">
              {{ item }}
            </li>
          </ul>
          <p>
            上記は別途料金が必要です。その他、ご要望に応じてご対応させていただきます。
          </p>
        </div>
      </div>
    </div>
  </section>
  <Contact></Contact>
  <Footer></Footer>
</template>
<script>
import Footer from "@/components/PartsFooter.vue";
import Header from "@/components/PartsPageHeader.vue";
import Contact from "@/components/PartsContact.vue";
export default {
  data() {
    return {
      basicplan: [
        "ホール使用料",
        "寝台車・霊柩車",
        "お棺",
        "名彫刻壺",
        "御位牌など",
        "遺影写真",
        "ドライアイス",
        "棺布団・綿花正装",
        "案内看板",
        "受付・ご焼香",
        "後飾り祭壇",
        "役所手続き",
      ],
      advancedplan: [
        "会葬礼状",
        "返礼品",
        "精進弁当",
        "白・薄紫棺を柄付棺に変更",
        "白無地壺を絵入壺に変更",
        "遺影額を紫檀内金額に変更",
      ],
    };
  },
  components: {
    Header,
    Footer,
    Contact,
  },
  setup() {},
};
</script>
<style lang="scss" scoped>
#contents {
  width: 100%;
  padding: 0 1rem;
  margin: 0 auto;
  .plan-wrap {
    background-color: white;
    padding: 4rem 1rem;
    max-width: $maxwidth;
    margin: 0 auto;
    counter-reset: section;

    .plan-item {
      margin: 0 auto;
      max-width: 880px;
      position: relative;
      &:last-child {
        margin-bottom: 0;
      }
      .tx {
        h3 {
          font-size: 2rem;
          padding-bottom: 2rem;
          margin-bottom: 2rem;
          border-bottom: 1px solid #ccc;
          @include tb {
            font-size: 1.5rem;
          }
        }
        p {
          line-height: 2;
          margin-bottom: 2rem;
        }
      }
    }
    .basicplan,
    .advancedplan {
      h4 {
        border: 1px solid #000;
        border-radius: 0.25rem;
        text-align: center;
        font-size: 1.5rem;
        padding: 0.5rem 1rem;
        margin-bottom: 1rem;
        @include tb {
          font-size: 1.25rem;
        }
      }
      p {
        line-height: 2;
        @include tb {
          font-size: 0.65rem;
        }
      }
      .grid {
        margin-bottom: 1rem;
      }
    }
    .basicplan {
      margin-bottom: 2rem;
      h4 {
        color: $color-hondo;
        border-color: $color-hondo;
      }
      .grid {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        grid-gap: 0.5em;
        @include tb {
          grid-template-columns: repeat(4, 1fr);
        }
        @include sp {
          grid-template-columns: repeat(3, 1fr);
        }
      }
    }
    .advancedplan {
      h4 {
        color: $color-nagai;
        border-color: $color-nagai;
      }
      .grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 0.5em;
        @include tb {
          grid-template-columns: repeat(2, 1fr);
        }
        @include sp {
          grid-template-columns: 1fr;
        }
        .item {
          background-image: url("@/assets/images/ico-plus.svg");
          background-repeat: no-repeat;
          background-position: 1rem center;
          background-color: #e1c7e4;
          background-size: 1.25rem 1.25rem;
          padding: 1rem 1rem 1rem 3rem;
          text-align: center;
          line-height: 1.5;
        }
      }
    }
  }
}
</style>
